import { render, staticRenderFns } from "./materialScrap.vue?vue&type=template&id=8b2a00dc&scoped=true"
import script from "./materialScrap.vue?vue&type=script&lang=js"
export * from "./materialScrap.vue?vue&type=script&lang=js"
import style0 from "./materialScrap.vue?vue&type=style&index=0&id=8b2a00dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2a00dc",
  null
  
)

export default component.exports